import _directionRightLine from "@zenlayer/zen-design-icons/assets/direction/RightLine.svg";
import _generalFilterFill from "@zenlayer/zen-design-icons/assets/general/FilterFill.svg";
import _componentSelectMenuItemSelectedIcon from "@zenlayer/zen-design-icons/assets/component/SelectMenuItemSelectedIcon.svg";
import classNames from 'classnames';
import React, { createElement as _createElement } from 'react';
import { pickDomAttrs } from '../_util/utils';
import { useConfig } from '../hooks/useConfig';
import Icon from '../icon';
import Tooltip from '../tooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const filterDropdownRender = props => {
  const {
    clearFilters,
    selectedKeys,
    setSelectedKeys,
    filters,
    confirm,
    filterMultiple = true,
    selectAllText
  } = props;
  const {
    locale: {
      Table: TableLocale
    }
  } = useConfig();
  const renderItem = (item, index) => {
    const itemAttrs = pickDomAttrs(item);
    const isSelected = selectedKeys.some(key => key === item.value);
    return /*#__PURE__*/_createElement("div", {
      ...itemAttrs.data,
      className: classNames('item', {
        ['item-selected']: isSelected
      }),
      key: index,
      onClick: () => {
        if (filterMultiple) {
          if (isSelected) {
            const newkeys = selectedKeys.filter(key => key !== item.value);
            setSelectedKeys(newkeys);
          } else {
            const newkeys = [...selectedKeys, item.value];
            setSelectedKeys(newkeys);
          }
          confirm({
            closeDropdown: false
          });
        } else {
          if (isSelected) {
            setSelectedKeys([]);
          } else {
            setSelectedKeys([item.value]);
          }
          confirm({
            closeDropdown: true
          });
        }
      }
    }, item.text, isSelected && /*#__PURE__*/_jsx(Icon, {
      className: "checkIcon",
      type: "component/SelectMenuItemSelectedIcon",
      fontSize: 16
    }));
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "filter-dropdown-wrap",
    children: [/*#__PURE__*/_jsxs("div", {
      className: classNames('item', {
        ['item-selected']: !(selectedKeys !== null && selectedKeys !== void 0 && selectedKeys.length)
      }),
      onClick: () => {
        clearFilters === null || clearFilters === void 0 || clearFilters();
        if (filterMultiple) {
          confirm({
            closeDropdown: false
          });
        } else {
          confirm({
            closeDropdown: true
          });
        }
      },
      children: [selectAllText || TableLocale.filter_selectAllText, !(selectedKeys !== null && selectedKeys !== void 0 && selectedKeys.length) && /*#__PURE__*/_jsx(Icon, {
        className: "checkIcon",
        type: "component/SelectMenuItemSelectedIcon",
        fontSize: 16
      })]
    }), filters === null || filters === void 0 ? void 0 : filters.map((item, index) => {
      if (item.children) {
        return /*#__PURE__*/_jsxs("div", {
          className: "group",
          children: [/*#__PURE__*/_jsx("div", {
            className: "group-title",
            children: item.text
          }), item.children.map(renderItem)]
        }, index);
      } else {
        return renderItem(item, index);
      }
    })]
  });
};
const FilterDropdownRender = filterDropdownRender;
export const singleFilterDropdownRender = props => {
  return /*#__PURE__*/_jsx(FilterDropdownRender, {
    ...props,
    filterMultiple: false
  });
};
export const filterIconRender = filtered => {
  return /*#__PURE__*/_jsx(Icon, {
    type: "general/FilterFill",
    fontSize: 14,
    className: classNames('filterIcon', {
      ['filterIcon-active']: !!filtered
    })
  });
};
export const Help = props => {
  const {
    title,
    tips,
    iconSize = 16,
    ...tooltipProps
  } = props;
  return /*#__PURE__*/_jsx(Tooltip.Help, {
    title: tips,
    iconType: "filled",
    iconSize: iconSize,
    iconClassName: "helpIcon",
    ...tooltipProps,
    children: title
  });
};
export const Info = props => {
  const {
    title,
    tips,
    iconSize = 16,
    ...tooltipProps
  } = props;
  return /*#__PURE__*/_jsx(Tooltip.Info, {
    title: tips,
    iconType: "filled",
    iconSize: iconSize,
    iconClassName: "infoIcon",
    ...tooltipProps,
    children: title
  });
};
export const expandIconRender = props => {
  const {
    expandable,
    expanded,
    onExpand,
    record
  } = props;
  if (expandable) {
    return /*#__PURE__*/_jsx(Icon, {
      type: "direction/RightLine",
      fontSize: 16,
      className: classNames('expandIcon', {
        ['expandIcon-expanded']: expanded
      }),
      onClick: e => {
        onExpand(record, e);
      }
    });
  }
  return null;
};